/* global squiz */

[...document.querySelectorAll(".video-card-story--js.cards__video")].map(
    (el) => {
        const dataAttr = {
            name: "data-video-id",
            value: el.getAttribute("data-video-id"),
        };
        squiz.fn.appendVideo(el, dataAttr);
    }
);
